import { request } from '@/api/httpClient'
import { RequestType } from '@/enums'

export async function staffGetEnquiryExpirationTime() {
  return request({
    method: 'staff/GetEnquiryExpirationTime'
  })
}

export async function staffUpdateEnquiryExpirationTime(newTime) {
  return request({
    method: 'staff/UpdateEnquiryExpirationTime',
    payload: {
      EnquiryOverdueHours: newTime
    }
  })
}

export async function staffUpdateAlternativePriceData(customerId, datasetId, anomalies) {
  return request({
    method: 'staff/UpdateAlternativePriceData',
    payload: {
      CustomerId: customerId,
      DatasetId: datasetId,
      Anomalies: anomalies
    }
  })
}

export async function staffGetFinancialGroups(customerId, datasetId) {
  return request({
    method: 'staff/GetFinancialGroups',
    payload: {
      CustomerId: customerId,
      DatasetId: datasetId
    }
  })
}

export async function staffGetAlternativePriceData({ customerId, datasetId, groupId, description, offset, limit }) {
  return request({
    method: 'staff/GetAlternativePriceData',
    payload: {
      CustomerId: customerId,
      DatasetId: datasetId,
      GroupId: groupId,
      Description: description,
      Offset: offset,
      Limit: limit
    }
  })
}

export async function staffUpdateProductSelectionGroups(groupList) {
  return request({
    method: 'staff/UpdateProductSelectionGroups',
    payload: {
      ProductSelection: groupList
    }
  })
}

export async function staffGetLatestExchangeRates() {
  return request({
    method: 'staff/GetLatestExchangeRates'
  })
}

export async function staffUpdateCurrency(currencyList) {
  return request({
    method: 'staff/UpdateCurrency',
    payload: {
      Currencies: currencyList
    }
  })
}

export async function staffUpdateProductSelectionTypes(groupList) {
  return request({
    method: 'staff/UpdateProductSelectionTypes',
    payload: {
      ProductSelection: groupList
    }
  })
}

export async function staffAssignEnquiry(contractId, userIds) {
  return request({
    method: 'staff/AssignEnquiry',
    payload: {
      ContractId: Number(contractId),
      CustomerIds: userIds
    }
  })
}

export async function staffUpdateOrganisationDetails(payload) {
  return request({
    method: 'staff/updateOrganisationDetails',
    payload
  })
}

export async function staffListCustomers(
  limit,
  offset,
  searchName,
  contractId,
  dealerNetworkPartnerOnly = false,
  CustomerStatus,
  generalLicenseStatus,
  BranchCompanyId,
  ExtruderLevel
) {
  const response = await request({
    method: 'staff/ListCustomers',
    payload: {
      limit,
      offset,
      searchName,
      GetTotal: true,
      ContractIDForDistance: contractId,
      DealerNetworkPartnerOnly: dealerNetworkPartnerOnly,
      CustomerStatus,
      generalLicenseStatus,
      BranchCompanyId,
      ContractId: contractId,
      ExtruderLevel
    }
  })
  return response
}

export async function staffGetOrganisationCustomerId() {
  const { customerId } = await request({
    method: 'staff/GetOrganisationCustomerId'
  })
  return customerId
}

export async function staffList() {
  const response = await request({
    method: 'staff/List'
  })
  return response.map((staffMember) => ({
    ...staffMember,
    url: `/staff/${staffMember.id}`
  }))
}

export async function staffGetTaxRates() {
  return request({
    method: 'staff/GetTaxRates'
  })
}

export async function staffUpdateTaxRates(TaxRates) {
  return request({
    method: 'staff/UpdateTaxRate',
    payload: {
      TaxRates
    }
  })
}

export async function staffAddTaxRate(TaxRate) {
  return request({
    method: 'staff/AddTaxRate',
    payload: {
      Name: TaxRate.name,
      Value: Number(TaxRate.value),
      IsDefault: TaxRate.isDefault
    }
  })
}

export async function staffDeleteTaxRate(id) {
  return request({
    method: 'staff/DeleteTaxRate',
    payload: {
      Id: Number(id)
    }
  })
}

export async function staffGetStaffContact(ContactId) {
  return request({
    method: 'staff/GetStaffContact',
    payload: {
      Id: Number(ContactId)
    }
  })
}

export async function staffEditStaffContact(Contact) {
  return request({
    method: 'staff/EditStaffContact',
    payload: Contact
  })
}

export async function staffCreateStaffContact(Contact) {
  return request({
    method: 'staff/CreateStaffContact',
    payload: Contact
  })
}

export async function staffGetDiscountList(datasetId) {
  return request({
    method: 'staff/GetDiscountList',
    payload: {
      Id: datasetId
    }
  })
}

export async function staffUpdateDiscountCategories(discounts) {
  return request({
    method: 'staff/UpdateDiscountCategories',
    payload: {
      DiscountCategories: discounts
    }
  })
}

export async function staffListDiscountCategories() {
  return request({
    method: 'staff/ListDiscountCategories'
  })
}

export async function staffGetCustomerDiscounts(customerId, datasetId) {
  const { discounts } = await request({
    method: 'staff/GetCustomerDiscounts',
    payload: {
      CustomerId: Number(customerId),
      DatasetId: datasetId
    }
  })
  return discounts
}

export async function staffUpdateDiscounts(customerId, datasetId, discounts) {
  return request({
    method: 'staff/UpdateDiscounts',
    payload: {
      CustomerId: Number(customerId),
      DatasetId: datasetId,
      Discounts: discounts.map((discount) => ({
        Id: discount.id,
        Value: Number(discount.value)
      }))
    }
  })
}

export async function staffGetBaseFinancials({ datasetId, limit, offset, groupId, description, financialType }) {
  return request({
    method: 'staff/GetBaseFinancials',
    payload: {
      limit,
      offset,
      datasetId,
      groupId,
      description,
      financialType
    }
  })
}

export async function staffGetFinancialOverrides(datasetId, financialId, limit, offset) {
  return request({
    method: 'staff/GetFinancialOverrides',
    payload: {
      limit,
      offset,
      datasetId,
      financialId
    }
  })
}

export async function staffUpdateBaseFinancials(datasetId, financials) {
  return request({
    method: 'staff/UpdateBaseFinancials',
    payload: {
      DatasetId: datasetId,
      Financials: financials
    }
  })
}

export async function staffUpdateBasePriceGrid(datasetId, financialId, financialGridConfigurationId, cells) {
  return request({
    method: 'staff/UpdateBasePriceGrid',
    payload: {
      DatasetId: datasetId,
      Id: financialId,
      FinancialGridConfigurationId: financialGridConfigurationId,
      Cells: cells
    }
  })
}

export async function staffUpdateBasePriceList(datasetId, financialId, financialGridConfigurationId, cells) {
  return request({
    method: 'staff/UpdateBasePriceList',
    payload: {
      DatasetId: datasetId,
      Id: financialId,
      FinancialGridConfigurationId: financialGridConfigurationId,
      Cells: cells
    }
  })
}

export async function staffGetBasePriceList(datasetId, financialId) {
  return request({
    method: 'staff/GetBasePriceList',
    payload: {
      DatasetId: datasetId,
      Id: financialId
    }
  })
}

export async function UpdateBaseValueWidthByHeight(datasetId, financialId, cells) {
  return request({
    method: 'staff/UpdateBaseValueWidthByHeight',
    payload: {
      DatasetId: datasetId,
      Id: financialId,
      Data: cells
    }
  })
}

export async function staffGetBasePriceGrid(datasetId, financialId) {
  return request({
    method: 'staff/GetBasePriceGrid',
    payload: {
      DatasetId: datasetId,
      Id: financialId
    }
  })
}

export async function staffUpdateFinancialGroups(datasetId, financialGroups) {
  return request({
    method: 'staff/UpdateFinancialGroups',
    payload: {
      DatasetId: datasetId,
      FinancialGroups: financialGroups
    }
  })
}

export async function staffMoveFinancialItems(datasetId, groupId, financialItemIds) {
  return request({
    method: 'staff/MoveFinancialItems',
    payload: {
      DatasetId: datasetId,
      GroupId: groupId,
      ItemIds: financialItemIds
    }
  })
}

export async function staffListStaff(limit, offset, branchCompanyId) {
  return request({
    method: 'staff/ListStaff',
    payload: {
      limit,
      offset,
      GetTotal: true,
      branchCompanyId
    }
  })
}

export async function staffGetThisListAnomaly(id, customerId, datasetId) {
  return request({
    method: 'staff/GetThisListAnomaly',
    payload: {
      Id: id,
      CustomerId: customerId,
      DatasetId: datasetId
    }
  })
}

export async function staffUpdateThisListAnomaly(datasetId, id, gridId, overrideCells, customerId) {
  return request({
    method: 'staff/UpdateThisListAnomaly',
    payload: {
      Id: id,
      CustomerId: customerId,
      OverrideCells: overrideCells,
      DatasetId: datasetId,
      FinancialGridConfigurationId: gridId
    }
  })
}

export async function staffGetDeliveryOptions(Name, Offset, Limit, DeliveryDays) {
  return request({
    method: 'staff/GetDeliveryOptions',
    payload: {
      Name,
      Offset,
      Limit,
      DeliveryDays
    }
  })
}

export async function staffUpdateDeliveryOptions(deliveryOption) {
  return request({
    method: 'staff/UpdateDeliveryOptions',
    payload: {
      DeliveryOptionDetails: deliveryOption
    }
  })
}

export async function staffGetPostCodes(Prefix, Offset, Limit) {
  return request({
    method: 'staff/GetPostcodes',
    payload: {
      Prefix,
      Offset,
      Limit
    }
  })
}

export async function staffUpdatePostcodes(PostCode) {
  return request({
    method: 'staff/UpdatePostcodes',
    payload: {
      PostcodeDetails: PostCode
    }
  })
}

export async function staffGetOptionHeadings() {
  const { headings } = await request({
    method: 'staff/GetOptionHeadings',
    requestType: RequestType.GET
  })
  return headings
}

export async function staffGetOptionItems(headingType) {
  const { items } = await request({
    method: `staff/GetOptionItems?headingType=${headingType}`,
    requestType: RequestType.GET
  })
  return items
}

export async function staffUpdateOptionItems(DatasetId, OptionItems) {
  return request({
    method: 'staff/UpdateOptionItems',
    payload: {
      DatasetId,
      items: OptionItems
    }
  })
}

export async function staffGetOptionGroups() {
  return request({
    method: 'staff/GetOptionGroups',
    requestType: RequestType.GET
  })
}

export async function staffGetFenestrationOptionGroups(datasetId) {
  return request({
    method: `staff/GetFenestrationOptionGroups?DatasetId=${datasetId}`,
    requestType: RequestType.GET
  })
}

export async function staffGetOptionHeadingsByGroup(groupId) {
  return request({
    method: `staff/GetOptionHeadingsByGroup?groupId=${groupId}`,
    requestType: RequestType.GET
  })
}

export async function staffGetFenestrationOptionHeadingsForGroup(datasetId, groupId) {
  return request({
    method: `staff/GetFenestrationOptionHeadingsForGroup?DatasetId=${datasetId}&OptionGroupId=${groupId}`,
    requestType: RequestType.GET
  })
}

export async function GetFenestrationOptionHeadings(datasetId) {
  return request({
    method: `staff/GetFenestrationOptionHeadings?DatasetId=${datasetId}`,
    requestType: RequestType.GET
  })
}

export async function GetRetailControlProducts() {
  return request({
    method: 'staff/GetProducts',
    requestType: RequestType.GET
  })
}

export async function staffGetCustomerOptionItems(headingType, customerId) {
  return request({
    method: `staff/GetCustomerOptionItems?headingType=${headingType}&customerId=${customerId}`,
    requestType: RequestType.GET
  })
}

export async function staffGetFenestrationOptionItemsForHeading(datasetId, headingType) {
  return request({
    method: `staff/GetFenestrationOptionItemsForHeading?DatasetId=${datasetId}&OptionHeadingId=${headingType}`,
    requestType: RequestType.GET
  })
}

export async function staffUpdateCustomerOptionItems(DatasetId, Items, CustomerId) {
  return request({
    method: 'staff/UpdateCustomerOptionItems',
    payload: {
      CustomerId,
      DatasetId,
      Items
    }
  })
}

export async function staffUpdateOptionConfigurations(DatasetId, OptionGroups, OptionHeadings, OptionItems) {
  return request({
    method: 'staff/UpdateOptionConfiguration',
    payload: {
      DatasetId,
      OptionGroups,
      OptionHeadings,
      OptionItems
    }
  })
}

export async function staffListDiscountVouchers(query) {
  return request({
    method: 'staff/ListDiscountVouchers',
    payload: query
  })
}

export async function staffCreateDiscountVoucher(voucher) {
  return request({
    method: 'staff/CreateDiscountVoucher',
    payload: voucher
  })
}

export async function staffUpdateDiscountVoucher(voucher) {
  return request({
    method: 'staff/UpdateDiscountVoucher',
    payload: voucher
  })
}

export async function staffDeleteDiscountVoucher(id) {
  return request({
    method: 'staff/DeleteDiscountVoucher',
    payload: { id }
  })
}

export async function staffGetBrandedFabricatorLimit() {
  return request({
    method: 'staff/GetBrandedFabricatorLimit'
  })
}

export async function staffListCustomerBrandedDetails(query) {
  return request({
    method: 'staff/ListCustomerBrandedDetails',
    payload: query
  })
}

export async function staffAddDocumentCategory(categoryName) {
  await request({
    method: 'staff/AddDocumentCategory',
    payload: {
      Name: categoryName
    }
  })
}

export async function staffUpdateDocumentCategory(category) {
  await request({
    method: 'staff/UpdateDocumentCategory',
    payload: {
      Id: Number(category.id),
      Name: category.name
    }
  })
}

export async function staffDeleteDocumentCategories(categoryIds) {
  return request({
    method: 'staff/DeleteDocumentCategories',
    payload: {
      Ids: categoryIds
    }
  })
}

export async function staffDeleteDocuments(documentIds) {
  return request({
    method: 'staff/DeleteDocuments',
    payload: {
      Ids: documentIds
    }
  })
}
